export const firebaseConfig = {
  apiKey: "AIzaSyD4NimURpoCn5KyR-Tpc6u-JvUxAZ-8g1U",
  authDomain: "rugby-ref-request.firebaseapp.com",
  projectId: "rugby-ref-request",
  storageBucket: "rugby-ref-request.appspot.com",
  messagingSenderId: "79805218836",
  appId: "1:79805218836:web:7655aceb78c918f7f16701"
};
